/*
*  Description: Show Notification Container after 10 seconds
*  Author: Christopher Krawietz
*
*/
(function ($, window) {
  'use strict';

  const init = () => {
    if (!getCookie("notificationShown")) {
      setTimeout(() => {
        $("#notification").fadeIn();
      }, 10000);
    }

    $("#notification-close").click(function() {
      $("#notification").fadeOut();
      setCookie("notificationShown", "true", 15);
    });
  }

  const setCookie = (cname, cvalue, exminutes) => {
    let d = new Date();
    d.setTime(d.getTime() + (exminutes*60*1000));
    let expires = "expires="+ d.toUTCString();
    document.cookie = `${cname}=${cvalue};${expires};path=/`;
  }

  const getCookie = (cname) => {
    let name = `${cname}=`;
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  $(document).ready(init);
}(jQuery, window));
